import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { PhysiologicalDataApi } from '../../../apis/PhysiologicalDataApi/PhysiologicalDataApi';
import { IPhysiologicalData } from '../PhysiologicalData';

export function useDeletePhysiologicalData() {
    const queryClient = useQueryClient();

    return useMutation<string, AppMedError, string>({
        mutationKey: [QueryKeys.physiologicalData],
        mutationFn: async (id: string) => {
            await PhysiologicalDataApi.deletePhysiologicalData(id);
            return id;
        },
        onSuccess: async (id: string) => {
            queryClient.setQueryData<IPhysiologicalData[]>([QueryKeys.physiologicalData], (prev) => {
                return prev?.filter(el => el.id !== Number(id)) || [];
            });
        },
    });
}